var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block_section_title"},[_vm._t("default"),_c('img',{attrs:{"src":require("../../assets/line.png"),"alt":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }